// 商品
import axios from 'axios'

// 商品列表(分页)
export function getProduct(data) {
  return axios({
    url: `/api/pms/product/listPage`,
    method: 'get',
    params: data
  })
}
// 商品查询(不分页)
export function getProductAll(data) {
  return axios({
    url: `/api/pms/product/list`,
    method: 'get',
    params: data
  })
}
// 新增商品
export function addProduct(data) {
  return axios({
    url: `/api/pms/product/insert`,
    method: 'post',
    data
  })
}
// 商品修改 
export function updateProduct(data) {
  return axios({
    url: `/api/pms/product/update`,
    method: 'post',
    data
  })
}
// 根据美团渠道ID获取商品
export function getChannelId(id) {
  return axios({
    url: `/api/pms/product/selectByChannelId?id=${id}`,
    method: 'get'
  })
}
// 根据ID获取商品
export function getProductId(id) {
  return axios({
    url: `/api/pms/product/selectById?id=${id}`,
    method: 'get'
  })
}
// 删除商品
// export function deleteProduct(id) {
//   return axios({
//     url: `/api/pms/product/delete?id=${id}`,
//     method: 'get',
//   })
// }
// get上传图片接口file
export function productUploadFile(data) {
  return axios({
    url: `/api/pms/product/uploadFile`,
    method: 'get',
    params: data
  })
}
// post上传图片接口file
export function productUploadFiles(data) {
  return axios({
    url: `/api/pms/product/uploadFile`,
    method: 'post',
    data
  })
}
// 商品库上传详情图片/轮播图
// get上传详情图片接口file
export function uploadDetailOnlineGet(data) {
  return axios({
    url: `/api/pms/product/uploadDetailFile`,
    method: 'get',
    params: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// post上传详情图片接口file
export function uploadDetailOnlinePost(data) {
  return axios({
    url: `/api/pms/product/uploadDetailFile`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// get上传轮播图片接口file
export function uploadCarouseOnlineGet(data) {
  return axios({
    url: `/api/pms/product/uploadCarouselFile`,
    method: 'get',
    params: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// post上传轮播图片接口file
export function uploadCarouseOnlinePost(data) {
  return axios({
    url: `/api/pms/product/uploadCarouselFile`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// post图片删除 filePath,ossFolderName
export function deleteFilesOnline(data) {
  return axios({
    url: `/api/pms/product/deleteFile`,
    method: 'post',
    params: data
  })
}
// get图片删除filePath,ossFolderName
export function deleteFileOnline(data) {
  return axios({
    url: `/api/pms/product/deleteFile`,
    method: 'get',
    params: data
  })
}
// 列举图片
export function listFileOnline(ossFolderName) {
  return axios({
    url: `/api/pms/product/listFile?ossFolderName=${ossFolderName}`,
    method: 'get'
  })
}
// 商品分类列表(分页)
export function getCategory(data) {
  return axios({
    url: `/api/pms/productCategory/listPage`,
    method: 'get',
    params: data
  })
}
// 商品分类查询(不分页)
export function getCategoryAll(data) {
  return axios({
    url: `/api/pms/productCategory/list`,
    method: 'get',
    params: data
  })
}
// 新增商品分类
export function addCategory(data) {
  return axios({
    url: `/api/pms/productCategory/insert`,
    method: 'post',
    data
  })
}
// 删除商品分类
export function deleteCategory(id) {
  return axios({
    url: `/api/pms/productCategory/delete?id=${id}`,
    method: 'get'
  })
}
// 修改商品分类
export function editCategory(data) {
  return axios({
    url: `/api/pms/productCategory/update`,
    method: 'post',
    data
  })
}

// 购物车列表(分页)
export function getShopping(data) {
  return axios({
    url: `/api/oms/cartItem/listPage`,
    method: 'get',
    params: data
  })
}
// 购物车查询(不分页)
export function getShoppingAll(data) {
  return axios({
    url: `/api/oms/cartItem/list`,
    method: 'get',
    params:data
  })
}
// 购物车新增
export function addShopping(data) {
  return axios({
    url: `/api/oms/cartItem/insert`,
    method: 'post',
    data
  })
}
// 购物车删除
export function deleteShopping(id) {
  return axios({
    url: `/api/oms/cartItem/delete?id=${id}`,
    method: 'get'
  })
}
// 购物车修改
export function updateShopping(data) {
  return axios({
    url: `/api/oms/cartItem/update`,
    method: 'post',
    data
  })
}
// 购物车集合修改
export function updateCartList(data) {
  return axios({
    url: `/api/oms/cartItem/updateList`,
    method: 'post',
    data
  })
}
// 购物车已支付
export function updatePaid(paySn) {
  return axios({
    url: `/api/oms/cartItem/updatePaid?paySn=${paySn}`,
    method: 'get'
  })
}

// 渠道商品
// 渠道商品列表(分页)
export function getProductChannelRel(data) {
  return axios({
    url: `/api/pms/productChannelRel/listPage`,
    method: 'get',
    params: data
  })
}
// 渠道商品查询(不分页)
export function getProductAllChannelRel(data) {
  return axios({
    url: `/api/pms/productChannelRel/list`,
    method: 'get',
    params: data
  })
}
// 渠道新增商品
export function addProductChannelRel(data) {
  return axios({
    url: `/api/pms/productChannelRel/insert`,
    method: 'post',
    data
  })
}
// 渠道商品修改
export function updateProductChannelRel(data) {
  return axios({
    url: `/api/pms/productChannelRel/update`,
    method: 'post',
    data
  })
}
// 根据美团渠道ID获取商品
export function getChannelIdChannelRel(id) {
  return axios({
    url: `/api/pms/productChannelRel/selectByChannelId?id=${id}`,
    method: 'get'
  })
}
// 渠道根据ID获取商品
export function getProductIdChannelRel(id) {
  return axios({
    url: `/api/pms/productChannelRel/selectById?id=${id}`,
    method: 'get'
  })
}
// 源渠道商品拷贝至目标渠道
export function sourceCopyTarget(source, target, targetName) {
  return axios({
    url: `/api/pms/productChannelRel/sourceCopyTargetByChannelId?sourceChannelId=${source}&targetChannelId=${target}&targetChannelName=${targetName}`,
    method: 'get'
  })
}

// 通过ID拷贝线上商品至门店商品
export function onlineCopyStore(id) {
  return axios({
    url: `/api/pms/productChannelRel/onlineCopyStore?id=${id}`,
    method: 'get'
  })
}

// get上传图片接口file
export function productUploadFileChannelRel(data) {
  return axios({
    url: `/api/pms/productChannelRel/uploadFile`,
    method: 'get',
    params: data
  })
}
// post上传图片接口file
export function productUploadFilesChannelRel(data) {
  return axios({
    url: `/api/pms/productChannelRel/uploadFile`,
    method: 'post',
    data
  })
}